import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from 'gung-standard';

@Component({
    selector: 'car-liner-included-items-modal',
    templateUrl: './car-liner-included-items-modal.component.html',
    styleUrls: ['./car-liner-included-items-modal.component.scss'],
    standalone: false
})
export class CarLinerIncludedItemsModalComponent implements OnInit {
  public includedItemIds: string[] = [];
  public product: Product;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.includedItemIds = [];

    if (this.product.extra.sr) {
      this.product.extra.sr.forEach(includedItem => {
        if (includedItem.bartnrstrukt) {
          this.includedItemIds.push(includedItem.bartnrstrukt);
        }
      });
    }
  }

  crossClick() {
    this.activeModal.dismiss('Cross click');
  }

  close(result?) {
    this.activeModal.close(result || 'Closed');
  }
}
